function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.16 8.09167C15.8578 7.80769 15.3675 7.80764 15.0652 8.09162C14.7629 8.37564 14.7628 8.8361 15.0652 9.12013L17.3564 11.2727H7.87086C7.4433 11.2727 7.09668 11.5983 7.09668 11.9999C7.09668 12.4016 7.4433 12.7272 7.87086 12.7272H17.3563L15.0652 14.8795C14.7628 15.1636 14.7628 15.624 15.0652 15.9081C15.2163 16.0501 15.4145 16.1211 15.6126 16.1211C15.8107 16.1211 16.0089 16.0501 16.16 15.9081L19.7727 12.5142C20.0751 12.2302 20.0751 11.7697 19.7727 11.4857L16.16 8.09167Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.4837 20C11.9113 20 12.2579 19.6744 12.2579 19.2727C12.2579 18.8711 11.9113 18.5455 11.4837 18.5455H5.54835V5.45455H11.4837C11.9113 5.45455 12.2579 5.12892 12.2579 4.72727C12.2579 4.32562 11.9113 4 11.4837 4H4.77418C4.34662 4 4 4.32562 4 4.72727V19.2727C4 19.6744 4.34662 20 4.77418 20H11.4837Z",
  fill: "white"
});

var SvgAcLogout = function SvgAcLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAcLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ac-logout.a606c76d.svg";
export { ForwardRef as ReactComponent };